import { render } from "./RecordView.vue?vue&type=template&id=66dde4ae&scoped=true"
import script from "./RecordView.vue?vue&type=script&lang=js"
export * from "./RecordView.vue?vue&type=script&lang=js"

import "./RecordView.vue?vue&type=style&index=0&id=66dde4ae&scoped=true&lang=css"

import exportComponent from "/Users/matsushitamasaya/webex/setouchi-webapp2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66dde4ae"]])

export default __exports__